/* eslint-disable @typescript-eslint/no-unused-vars */
import { reportCodeTryException } from '@/src/common/exception';
import * as React from 'react';

const Raptor = Mach.requireModule('Raptor');

export class SubBaseCommponent<P = {}, S = {}, SS = any> extends React.Component<P, S, SS> {
  // 获取关键Dom节点
  public getKeyDomInfo = () => ({})

  /**
     * 通参
     */
  defaultTags = {
    appVersion: Mach.env.version ?? '',
    platform: Mach.env.isAndroid ? 'Android' : 'iOS',
    bundleVersion: Mach.env.bundleVersion,
    bundleName: Mach.env.bundleName,
  }

  // 校验核心dom展示成功率
  public checkKeyDomSuccessRate = () => {
    try {
      const keyDomInfo = this.getKeyDomInfo();
      const keyDomRef = keyDomInfo?.domRef;
      const subBundleName = this.props.apiData?.component_id;
      if (!globalThis.recordCheckKeyDomInfo) {
        globalThis.recordCheckKeyDomInfo = {};
      }
      const checkInfo = globalThis.recordCheckKeyDomInfo[subBundleName];
      const mainPageRef = globalThis.mainPageRef;
      if (!globalThis.hornConfig) {
        const Horn = Mach.requireModule('SLCHorn');
        const config = Horn?.getAppConfig?.();
        globalThis.hornConfig = config;
      }
      const checkKeyDomSwitch = globalThis.hornConfig?.checkKeyDomSwitch ?? false;
      // 使用measureInView、measureInWindow时要先判断当前页面是否可见，否则在iOS端会因为组件window不可见导致计算结果错误
      const isPageVisible = Mach.env.isIOS ? Mach.env.isPageVisible : true;
      if (!checkKeyDomSwitch || !keyDomRef || !mainPageRef || !subBundleName || checkInfo || !isPageVisible) {
        return;
      }
      let displaySuccess = true;
      const frame = keyDomRef?.measureInView?.(mainPageRef);
      const height = frame?.height || 0;
      const offsetY = frame?.y || 0;
      let yValue = 1;
      if (globalThis.scrollerContentOffsetY >= 0 && offsetY < 0) {
        // 当前检测dom的y轴小于0时，判断列表的偏移量是否大于等于dom的Y轴，若大于等于offsetY则说明组件展示没有问题
        displaySuccess = height > 0 && globalThis.scrollerContentOffsetY >= Math.abs(offsetY);
        yValue = globalThis.scrollerContentOffsetY >= Math.abs(offsetY) ? 1 : 0;
      } else {
        displaySuccess = height > 0;
      }
      const status = displaySuccess ? 1 : 0;
      // 高度是否大于0
      const hValue = height > 0 ? 1 : 0;
      globalThis.recordCheckKeyDomInfo[subBundleName] = { status };
      const tags = {
        ...this.defaultTags, subBundleName, status, yValue, hValue
      };
      this.reportMetrics({ SubBundleDisplaySuccessRate: status }, tags);
    } catch (error) {
      // 捕获到异常上报
      reportCodeTryException({
        message: 'checkKeyDom',
        extra: error
      });
    }
  }

  /**
     * 上报Report监控指标
     * @param params
     * @param tags
     */
  reportMetrics = (params, tags) => {
    const envName = Mach.env.isDebug ? 'Test' : 'Prod';
    const tagsObj = { ...tags, env: envName };
    // 校验tag数据是否为字符串
    const tagParams = this.checkAndConvertToString(tagsObj);
    Raptor?.reportMetrics?.(params, tagParams, 1);
  }

  /**
     * 检查Value类型是否为字符串并转换
     * @param obj
     * @returns
     */
  checkAndConvertToString = (obj) => {
    if (Array.isArray(obj) || typeof obj !== 'object') {
      return obj;
    }
    const convertObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'string') {
          convertObj[key] = obj[key];
        } else if (typeof obj[key] === 'number') {
          convertObj[key] = String(obj[key]);
        }
      }
    }
    return convertObj;
  }
}
